import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-log-call',
  templateUrl: './log-call.component.html',
  styleUrls: ['./log-call.component.scss']
})
export class LogCallComponent implements OnInit {

  constructor(
  ) { }

  ngOnInit() {

  }

}
